@let selectedMode = selectedMode$ | async;

<div id="catalog">
  <div class="top">
    <div class="header">
      <div class="banner">
        <div class="filter"></div>
        @if (!selectedVotw) {
          <ng-container>
            <img
              [src]="videosOfTheWeek[0]?.thumbnails.large"
              alt="Catalog Banner" />
          </ng-container>
        } @else {
          <div class="background-video-wrapper">
            @for (votw of [selectedVotw]; track votw.urls.hd) {
              <video
                @backgroundVideoFade
                class="background-video"
                loop
                [muted]="'muted'"
                autoplay
                playsinline
                preload="auto"
                data-wf-ignore="true"
                [poster]="votw.thumbnails.large"
                [src]="votw.urls.hd"
                type="video/mp4"></video>
            }
          </div>
        }
        <div class="search-container">
          <div class="search">
            <app-search-bar
              [(typedTerm)]="typedTerm"
              [isSubmitted]="isSearchSubmitted"
              (searchTerm)="onSearchTerm($event)" />
            <span class="separator" translate>compatibility.or</span>
            <a
              [routerLink]="['/browse/search']"
              [queryParams]="{ display: 'map' }">
              <kin-btn color="primary">{{
                'browse.explore-map' | translate
              }}</kin-btn>
            </a>
          </div>
          @if ((width$ | async) > 1000) {
            <div class="searched-terms">
              @for (searchedTerm of searchedTerms$ | async; track $index) {
                <button
                  [ngClass]="{
                    active: typedTerm === searchedTerm,
                  }"
                  (click)="onClickSearchedTerm(searchedTerm)">
                  <span class="icon icon-search"></span>
                  <span>{{ searchedTerm }}</span>
                </button>
              }
            </div>
          }
        </div>
        <h1>
          <!-- <span class="title title-1">{{ 'browse.title' | translate }}</span> -->
          <span class="title title-2">{{ 'browse.title-2' | translate }}</span>
        </h1>
      </div>

      <div id="videosZone">
        <app-horizontal-scroller
          [itemType]="CarouselItems.VOTW"
          [activeItemId]="selectedVotw?.id">
          <div class="scroll-wrapper">
            <div id="videosOfTheWeek">
              @for (video of videosOfTheWeek; track $index) {
                <div
                  (mouseenter)="onSelectOrUnselectVideoOfTheWeek(video.id)"
                  (mouseleave)="onSelectOrUnselectVideoOfTheWeek()"
                  [id]="'item-' + video.id"
                  class="similar card-container">
                  @let isAnimated =
                    selectedVotw && selectedVotw.id !== video.id;
                  <kin-scenic-card
                    [information]="video"
                    [size]="
                      (smallScreen$ | async) || (xSmallScreen$ | async)
                        ? 'small'
                        : 'medium'
                    "
                    [animate]="isAnimated"
                    [condensed]="true"
                    (onAuthorClick)="redirect(video.author.id, 'author')"
                    (onCardClick)="redirect(video.id, 'browse')"
                    (onFavoriteClick)="onLikeClick(video)" />
                </div>
              }
            </div>
          </div>
        </app-horizontal-scroller>
      </div>
    </div>
    <div id="scrollLandmark"></div>
    <div id="catalogToolbar" [ngClass]="{ fixed: isToolbarFixed }">
      <app-catalog-toolbar [isFixed]="isToolbarFixed" [isHome]="isHomeMode" />
    </div>
  </div>
  <div class="bottom">
    @if (selectedMode.name === ModeNames.Videos) {
      <app-catalog-video
        (activateOrDeactivateHomeMode)="
          onActivateOrDeactivateHomeMode($event)
        " />
    } @else {
      <ng-container>
        @if (selectedMode.name !== ModeNames.Library) {
          <app-listing [modeName]="selectedMode.name" />
        }

        @if (selectedMode.name === ModeNames.Library) {
          <ng-container>
            <app-catalog-library />
          </ng-container>
        }
      </ng-container>
    }
  </div>
</div>
